export default __webpack_public_path__ + "static/media/Openstory_logo_large.3ac4a3af.png";